import React, {useEffect} from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Link,
  useLocation
} from 'react-router-dom'
import HomePage from "./loggedout/HomePage";
import {LoggedOutRoutes} from "../LoggedOutRoutes";
import FeaturesPage from "./loggedout/FeaturesPage";
import HowtoPage from "./loggedout/HowtoPage";
import Store from "../lib/Store";
import PrivacyPolicyPage from "./loggedout/PrivacyPolicyPage";
import CookiePolicyPage from "./loggedout/CookiePolicyPage";
import TermsConditionsPage from "./loggedout/TermsConditionsPage";
import AcceptableUsePage from "./loggedout/AcceptableUsePage";
import FaqPage from "./loggedout/FaqPage";
import NotFoundLoggedOutPage from "./misc/NotFoundLoggedOutPage";
import ErrorLoggedOutPage from "./misc/ErrorLoggedOutPage";
import DSARPage from "./loggedout/DsarPage";
import LoginButton from "./auth/LoginButton";

function ScrollToTop() {
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function LoggedOutApp() {

  useEffect(() => {
    Store.delete("api_token");
  }, []);

  const showConsentPreferences = (e) => {
    e.preventDefault();

    if (window.displayPreferenceModal) {
      window.displayPreferenceModal();
    }
  }

  return (
      <Router>
        <ScrollToTop />

        <div className="lo">
          <header className="lo-nav">
            <div className="lo-nav-inner">
              <Link className="lo-brand" to={LoggedOutRoutes.HOME}>
                <img src="/static/img/nzyme-logo.svg" alt="Nzyme" />
                <span>Connect</span>
              </Link>

              <nav className="lo-nav-links" aria-label="Main">
                <NavLink to={LoggedOutRoutes.HOME} end>Home</NavLink>
                <NavLink to={LoggedOutRoutes.FEATURES}>Features</NavLink>
                <NavLink to={LoggedOutRoutes.FAQ}>FAQ</NavLink>
                <NavLink to={LoggedOutRoutes.HOWTO}>How To</NavLink>
              </nav>

              <div className="lo-nav-cta">
                <LoginButton className="btn btn-sm btn-primary" />
              </div>
            </div>
          </header>

          <main className="lo-main">
            <Routes>
              <Route path={LoggedOutRoutes.HOME} element={<HomePage/>}/>
              <Route path={LoggedOutRoutes.FEATURES} element={<FeaturesPage/>}/>
              <Route path={LoggedOutRoutes.FAQ} element={<FaqPage/>}/>
              <Route path={LoggedOutRoutes.HOWTO} element={<HowtoPage/>}/>

              <Route path={LoggedOutRoutes.DSAR} element={<DSARPage/>}/>
              <Route path={LoggedOutRoutes.PRIVACY_POLICY} element={<PrivacyPolicyPage/>}/>
              <Route path={LoggedOutRoutes.COOKIE_POLICY} element={<CookiePolicyPage/>}/>
              <Route path={LoggedOutRoutes.TERMS_CONDITIONS} element={<TermsConditionsPage/>}/>
              <Route path={LoggedOutRoutes.ACCEPTABLE_USE} element={<AcceptableUsePage/>}/>

              { /* Error. (Used by Auth0) */}
              <Route path={LoggedOutRoutes.ERROR} element={<ErrorLoggedOutPage/>}/>

              { /* Catch-all / 404. */}
              <Route path="*" element={<NotFoundLoggedOutPage />}/>
            </Routes>
          </main>

          <footer className="lo-footer">
            <div className="lo-footer-inner">
              <div>
                <Link className="lo-footer-brand" to={LoggedOutRoutes.HOME}>
                  <img src="/static/img/nzyme-logo.svg" alt="Nzyme" />
                  <span>Connect</span>
                </Link>
                <ul>
                  <li><a href="https://www.nzyme.org/" target="_blank">nzyme.org</a></li>
                  <li><a href="https://go.nzyme.org/contact" target="_blank">Contact</a></li>
                </ul>
              </div>

              <div>
                <h4>Legal</h4>
                <ul>
                  <li><Link to={LoggedOutRoutes.TERMS_CONDITIONS}>Terms &amp; Conditions</Link></li>
                  <li><Link to={LoggedOutRoutes.ACCEPTABLE_USE}>Acceptable Use Policy</Link></li>
                  <li><Link to={LoggedOutRoutes.PRIVACY_POLICY}>Privacy Policy</Link></li>
                  <li><Link to={LoggedOutRoutes.COOKIE_POLICY}>Cookie Policy</Link></li>
                </ul>
              </div>

              <div>
                <h4>Your Data</h4>
                <ul>
                  <li>
                    <a href="#" id="termly-consent-preferences" onClick={showConsentPreferences}>
                      Consent Preferences
                    </a>
                  </li>
                  <li><Link to={LoggedOutRoutes.DSAR}>Data Subject Access Request</Link></li>
                </ul>
              </div>
            </div>
          </footer>
        </div>
      </Router>
  )

}
